module.exports = __webpack_public_path__ + "img/profile-bw.e099dd5e.jpg";